import { render, staticRenderFns } from "./CompanyUserDetail.vue?vue&type=template&id=6826ff90&"
import script from "./CompanyUserDetail.vue?vue&type=script&lang=ts&"
export * from "./CompanyUserDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports